import { Typography, Button, Card, Row, Col, Badge } from 'antd';
import { Check, Zap } from 'lucide-react';

const { Title } = Typography;

const plans = [
    {
        title: "Monthly",
        price: "0.99",
        oldPrice: "2.99",
        period: "/month",
        features: ["Unlimited Notes", "Cross-Platform Sync", "End-to-End Encryption"],
        cta: "Start 7-Day Free Trial",
        highlight: false
    },
    {
        title: "Yearly",
        price: "9.99",
        oldPrice: "29.99",
        period: "/year",
        features: ["All Monthly Features", "Priority Support", "Early Access to Features"],
        cta: "Start 7-Day Free Trial",
        highlight: false,
        savings: "Save 70%"
    },
    {
        title: "Lifetime",
        price: "89.99",
        oldPrice: "299.99",
        period: "one-time",
        features: ["Lifetime Access", "No Recurring Fees", "Founder's Badge"],
        cta: "Get Lifetime Access",
        highlight: true,
        tag: "BEST DEAL"
    }
];

export default function PricingSection() {
    return (
        <div className="section pricing-section" id="pricing">
            <div className="section-container">
                <div className="section-header">
                    <div className="sale-banner">
                        <Zap size={16} fill="currentColor" /> Limited Offer: First 500 Customers Only
                    </div>
                    <Title level={2}>Simple, Transparent Pricing</Title>
                    <p className="section-subtitle">Unlock the full power of context-aware note taking.</p>
                </div>

                <Row gutter={[24, 24]} justify="center" align="middle">
                    {plans.map((plan, index) => (
                        <Col xs={24} md={8} key={index}>
                            <Card
                                className={`pricing-card ${plan.highlight ? 'highlight-card' : ''}`}
                                bordered={false}
                            >
                                {plan.tag && <div className="card-tag">{plan.tag}</div>}
                                <div className="pricing-header">
                                    <h3 className="plan-title">{plan.title}</h3>
                                    <div className="price-wrapper">
                                        <div className="old-price">${plan.oldPrice}</div>
                                        <div className="current-price-row">
                                            <span className="currency">$</span>
                                            <span className="amount">{plan.price}</span>
                                            <span className="period">{plan.period}</span>
                                        </div>
                                    </div>
                                    {plan.savings && <div className="savings-badge">{plan.savings}</div>}
                                </div>

                                <div className="pricing-features">
                                    {plan.features.map((feature, idx) => (
                                        <div className="feature-item" key={idx}>
                                            <Check size={18} color="#34d399" /> <span>{feature}</span>
                                        </div>
                                    ))}
                                </div>

                                <Button
                                    type="primary"
                                    size="large"
                                    block
                                    className={`pricing-cta ${plan.highlight ? 'highlight-btn' : ''}`}
                                >
                                    {plan.cta}
                                </Button>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        </div>
    );
}
